function AudioPlayer(props) {
  const { src } = props;
  return (
    <audio
      controls
      preload="auto"
    >
      <source src={src}/>
    </audio>
  );
}

export default AudioPlayer;
